export default {
  appName     : 'MiniPOS',
  globalError : '發生錯誤，請聯絡技術人員！',
  navbar      : {
    contact  : '聯絡我們',
    getapps  : '立即體驗',
    language : {
      tw : '繁體中文',
      cn : '简体中文',
      en : 'English'
    }
  },
  features : {
    customization          : '省成本',
    feature_1_1            : '毋須加購硬體設備',
    feature_1_2            : '節省發票作業的人力成本',
    feature_1_3            : '提供電子支付功能，節省應對現金問題產生的成本',
    privacy_security       : '省時間',
    feature_2_1            : '每期自動領取字軌',
    feature_2_2            : '發票開立後即上傳，毋須蒐集紙本申報',
    feature_2_3            : '平台統一處理電子支付退款，不用跨平台操作',
    streamlining_processes : '好上手',
    feature_3_1            : 'APP 商店直接取得更新',
    feature_3_2            : '專人輔導開通使用電子發票',
    feature_3_3            : '介面簡單易懂'
  },
  contact : {
    subject       : 'Whsip聯絡我們信件',
    submitSuccess : '成功送出！',
    continue      : '繼續填寫新訊息？'
  },
  redirect : {
    errorMessageTitle : '發生錯誤！'
  },
  formTemplate : {
    upload       : '上傳檔案',
    reset        : '重填',
    submit       : '確定送出',
    input        : '輸入',
    choose       : '選擇',
    beforeRemove : '確定移除',
    handleExceed : '最多上傳一張,請先刪除上一選項',
    error        : '失敗',
    cancel       : '取消'
  },
  form : {
    required            : '「{field}」為必填。',
    emailRequireMessage : '請輸入email',
    emailFormatMessage  : 'Email 格式錯誤',
    emailPlaceholder    : '請輸入email',
    imageSizeLimitMb    : '圖片不得超過{limit}mb。',
    buttonConfirm       : '確定',
    search              : '搜尋',
    clear               : '清除',
    back                : '返回'
  },
  policy : {
    copyright : '著作權聲明',
    privacy   : '隱私權政策'
  },
  errorPage : {
    403 : {
      p1 : '您沒有權限訪問該頁面',
      p2 : '返回首頁',
      p3 : '返回上一頁'
    },
    404 : {
      p1 : '您訪問的頁面不存在！',
      p2 : '返回首頁',
      p3 : '返回上一頁'
    }
  }
}
